import { Divider, Grid, Typography } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import React from 'react'
import { useStyles } from './index'
import { API_STATUS } from '../../../features/API/ApiHandler'

const DialogHeader = ({ state, isNewQuestionnaire, ...props }) => {
  const classes = useStyles()

  return (
    <div className={classes.stickyTop}>
      <Grid
        container
        direction='row'
        justifyContent='space-between'
        alignItems='center'
        {...props}
      >
        <Grid item>
          <Typography variant='h6' style={{ userSelect: 'none' }}>
            {isNewQuestionnaire
              ? 'Create new questionnaire'
              : 'Save questionnaire'}
          </Typography>
        </Grid>
        {state.status === API_STATUS.LOADING ? (
          <Grid item>
            <CircularProgress />
          </Grid>
        ) : null}
      </Grid>
      <Divider />
    </div>
  )
}

export default DialogHeader
